import { createContext } from 'react';

export interface ThemeConfiguration {
  name: string;
  variables: {
    [key: string]: string;
  };
  palettes: {
    [key: string]: string[];
  };
  gradients: {
    [key: string]: Array<{
      offset: string;
      stopOpacity: number;
      color: string;
    }>;
  };
}

export const ThemeContext = createContext<ThemeConfiguration>({} as any);
